import * as THREE from 'three';


export default class AssetsLoader{
    
    constructor(){
        this.IMAGES = [];
        this.textures = {};
    }


    load(images, callback=null){
        this.IMAGES = images;
        this.callback = callback;
        this._loadImages();
    }

    
    get _textures(){
        return this.textures;
    }


    async _loadImages(){
        const promises = [];
        for(let i = 0; i < this.IMAGES.length; i++) {
            promises[i] = this._loadTexture(this.IMAGES[i].src)
        }

        const res = await Promise.all(promises);

        for(let i=0; i<res.length; i+=1) {
            const key = this.IMAGES[i].key;
            this.textures[key] = res[i];
        }

        // すぐにコールバックした場合、JS内で参照するサイズが正確でない場合があるので、
        // 少し時差にする
        setTimeout(()=>{
            this._loadComplete();
        }, 500);
    }

    _loadTexture(url){

        return new Promise(resolve => {
            const loader = new THREE.TextureLoader();
            loader.crossOrigin = '*';
            loader.load(url, resolve);
        });
    }

    _loadComplete(){
        this.callback();
    }
}
